import { FormFieldConfig } from '@shared/components/search-form/search-form.component';
import { TableColumn } from '@shared/components/data-table/data-table.component';

export const RETURN_EXCEPTION_STATUS = {
  PENDING_APPROVAL: 'PENDING_APPROVAL',
  APPROVED: 'APPROVED',
  INVALID: 'INVALID',
} as const;

export type ReturnExceptionStatusCode =
  (typeof RETURN_EXCEPTION_STATUS)[keyof typeof RETURN_EXCEPTION_STATUS];

export const RETURN_EXCEPTION_DEFAULT_COLUMNS = {
  TICKET_CODE: 'ticketCode',
  STORE: 'storeDisplay',
  CUSTOMER_PHONE: 'customerPhone',
  STATUS: 'status',
  CREATED_AT: 'creationDate',
} as const;

export const RETURN_EXCEPTION_ACTION_COLUMN = {
  ACTIONS: 'actions',
} as const;

export const RETURN_EXCEPTION_DEFAULT_COLUMNS_ORDER: string[] = [
  RETURN_EXCEPTION_DEFAULT_COLUMNS.TICKET_CODE,
  RETURN_EXCEPTION_DEFAULT_COLUMNS.STORE,
  RETURN_EXCEPTION_DEFAULT_COLUMNS.CUSTOMER_PHONE,
  RETURN_EXCEPTION_DEFAULT_COLUMNS.STATUS,
  RETURN_EXCEPTION_DEFAULT_COLUMNS.CREATED_AT,
];

export const RETURN_EXCEPTION_FLEXIBLE_COLUMNS_ORDER: string[] = [
  'customerName',
  'reasonCode',
];

export const RETURN_EXCEPTION_TABLE_COLUMNS: TableColumn[] = [
  {
    label: 'return_exception.table.ticket_code',
    prop: RETURN_EXCEPTION_DEFAULT_COLUMNS.TICKET_CODE,
    width: 180,
  },
  {
    label: 'return_exception.table.store',
    prop: RETURN_EXCEPTION_DEFAULT_COLUMNS.STORE,
    width: 200,
  },
  {
    label: 'return_exception.table.customer_phone',
    prop: RETURN_EXCEPTION_DEFAULT_COLUMNS.CUSTOMER_PHONE,
    width: 140,
  },
  {
    label: 'return_exception.table.status',
    prop: RETURN_EXCEPTION_DEFAULT_COLUMNS.STATUS,
    width: 140,
    type: 'status',
  },
  {
    label: 'return_exception.table.created_at',
    prop: RETURN_EXCEPTION_DEFAULT_COLUMNS.CREATED_AT,
    width: 170,
    type: 'custom',
  },
  {
    label: 'return_exception.table.customer_name',
    prop: 'customerName',
    width: 160,
  },
  {
    label: 'return_exception.table.reason_code',
    prop: 'reasonCode',
    width: 140,
  },
  {
    label: 'common.table.actions',
    prop: RETURN_EXCEPTION_ACTION_COLUMN.ACTIONS,
    width: 220,
    type: 'actions',
  },
];

export const RETURN_EXCEPTION_SEARCH_CONFIG: FormFieldConfig[] = [
  {
    key: 'ticketCode',
    label: 'return_exception.search.ticket_code',
    type: 'text',
    placeholder: 'return_exception.search.ticket_code_placeholder',
    width: '200px',
  },
  {
    key: 'storeCode',
    label: 'return_exception.search.store_code',
    type: 'text',
    placeholder: 'return_exception.search.store_code_placeholder',
    width: '180px',
  },
  {
    key: 'customerPhone',
    label: 'return_exception.search.customer_phone',
    type: 'text',
    placeholder: 'return_exception.search.customer_phone_placeholder',
    width: '180px',
  },
  {
    key: 'status',
    label: 'return_exception.search.status',
    type: 'select',
    placeholder: 'return_exception.search.status_placeholder',
    width: '200px',
    showClear: true,
    options: [
      {
        label: 'return_exception.status.pending_approval',
        value: RETURN_EXCEPTION_STATUS.PENDING_APPROVAL,
      },
      {
        label: 'return_exception.status.approved',
        value: RETURN_EXCEPTION_STATUS.APPROVED,
      },
      {
        label: 'return_exception.status.invalid',
        value: RETURN_EXCEPTION_STATUS.INVALID,
      },
    ],
  },
];

export const RETURN_EXCEPTION_DEFAULT_CONFIG = {
  PAGE_SIZE: 20,
  DEFAULT_SORT_FIELD: 'creationDate',
  DEFAULT_SORT_ASCENDING: false,
} as const;
